import * as yup from "yup";

export const validationResourcesSchema = yup.object().shape({
    project_resources_id: yup.number().nullable().optional(),
    project_id: yup.number().required(),
    group_card: yup.number().label("Group").required(),
    card_id: yup.number().label("Trader").required(),
    card_name:yup.string().nullable().optional(), 
    description: yup.string().label("Duty of care").required(),
    employee_id: yup.number().label("Reported to").required(),
    employee_name:yup.string().nullable().optional(), 
    status: yup.string().nullable().optional(),
});

export const validationFormResourcesSchema =  yup.object().shape({
    items:yup.array().of(validationResourcesSchema).min(1, "At least one item must be filled in").required("Data is required"),
})
export type DataResourcesType = yup.InferType<typeof validationResourcesSchema>;
export type FormResourcesType = yup.InferType<typeof validationFormResourcesSchema>;